var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconModuleLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-9b46452f-c2b1-4ef0-9f3a-29311ba22497",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.72,
    height: 14.33,
    viewBox: "0 0 12.72 14.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-89281d38-16c7-4614-bd6f-bdc7c73cebe3",
    "data-name": "Object"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M.21,14.33c-.12,0-.21-.1-.21-.21V.21c0-.12.1-.21.21-.21s.21.1.21.21v13.9c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.27,7.57c-.31,0-.62-.03-.92-.09l-2.74-.57c-.09-.02-.15-.09-.15-.18V.32c0-.06.03-.11.07-.15.04-.04.1-.05.16-.04l2.74.57c.56.12,1.14.12,1.7,0l1.83-.56c.63-.13,1.26-.13,1.88,0l2.74.57c.09.02.15.09.15.18v6.41c0,.06-.03.11-.07.15-.04.04-.1.05-.16.04l-2.74-.57h0c-.57-.12-1.14-.12-1.71,0l-1.83.56c-.32.07-.64.1-.95.1ZM1.83,6.57l2.59.54c.56.12,1.14.12,1.7,0l1.83-.56c.64-.13,1.26-.13,1.88,0l2.51.52V1.03l-2.59-.53c-.57-.12-1.14-.12-1.71,0l-1.83.56c-.63.13-1.26.13-1.87,0L1.83.55v6.02Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModuleLocation);
export default __webpack_public_path__ + "static/media/icon_module_location.e3be481ce7fe5bd0852ca8b31b2b2b3c.svg";
export { ForwardRef as ReactComponent };